import angular from 'angular';

/* globals Knitiv */

export default class ListController {
	/** @type {boolean} */
	showList;

	/** @type {boolean} */
	showPreview;

	/* @ngInject */
	constructor(
		/** @type {Knitiv.RootScope} */
		$rootScope,
		/** @type {Knitiv.Scope} */
		$scope,
	) {
		this.row = undefined;
		this.showSearch = undefined;
		this.tab = undefined;

		this.showList = true;
		this.showPreview = true;

		$scope.$on('List.toggle-list', (event, value) => {
			// this.showList = value;
			switch (value) {
			case 'full': {
				angular.element('.kn-list').css('flex-basis', '100%');
				break;
			}
			case 'hidden': {
				angular.element('.kn-list').css('flex-basis', '0%');
				break;
			}
			case 'split': {
				angular.element('.kn-list').css('flex-basis', '50%');
				break;
			}
			default: {
				console.error('unsupported case', value);
				break;
			}
			}
		});

		$scope.$on('angular-resizable.resizing', () => {
			$rootScope.$broadcast('list-header-resize');
			$scope.$broadcast('List.resizing');
		});

		$scope.$on('angular-resizable.resizeEnd', (event, info) => {
			$scope.$broadcast('List.resizeEnd');
			if (info.width < 25 && $rootScope.showSearch) {
				angular.element('.kn-list').css('flex-basis', 0);
				$rootScope.showSearch = false;
			}
			else if (info.width >= 25 && !$rootScope.showSearch) {
				$rootScope.showSearch = true;
			}

			if (info.width < 500) {
				$rootScope.viewerDeployed = true;
			}
			else if (info.width >= 500) {
				$rootScope.viewerDeployed = false;
			}
		});
	}
}
